import {CassandraRootStateType} from '../reducer'
import {EnvState} from './types'

export const getEnvironmentSelector = (state: {cassandra: CassandraRootStateType}): EnvState =>
  state.cassandra.env
